<div class="episode-list-container">
  <!-- Header -->
  <header class="page-header">
    <h1>{{ pageTitle }}</h1>
    <p class="episode-count" *ngIf="!isLoading && !error">
      {{ totalItems }} episodi trovati
    </p>
  </header>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Caricamento episodi...</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-icon">⚠️</div>
    <p>{{ error }}</p>
    <button class="btn-retry" (click)="loadEpisodes()">Riprova</button>
  </div>

  <!-- Episodes Grid -->
  <div class="episodes-grid" *ngIf="!isLoading && !error && episodes.length > 0">
    <article class="episode-card" *ngFor="let episode of episodes">
      <!-- Cover Image con link -->
      <a [routerLink]="['/episodi', episode.slug]" class="episode-cover-link">
        <div class="episode-cover">
          <img 
            [src]="getCoverImageUrl(episode.coverImage, 'medium')" 
            [alt]="episode.title"
            loading="lazy"
          />
          <div class="duration-badge">
            {{ formatDuration(episode.duration) }}
          </div>
        </div>
      </a>

      <!-- Content -->
      <div class="episode-content">
        <a [routerLink]="['/episodi', episode.slug]" class="episode-title-link">
          <h2 class="episode-title">{{ episode.title }}</h2>
        </a>
        
        <p class="episode-description">
          {{ episode.description }}
        </p>

        <div class="episode-meta">
          <a 
            *ngIf="episode.categorySlug" 
            [routerLink]="['/categoria', episode.categorySlug]"
            class="category"
            (click)="$event.stopPropagation()"
          >
            {{ episode.categoryName }}
          </a>
          <span *ngIf="!episode.categorySlug" class="category">
            {{ episode.categoryName }}
          </span>
          <span class="date">{{ formatDate(episode.publishedAt) }}</span>
        </div>

        <div class="episode-tags" *ngIf="episode.tagNames.length > 0">
          <ng-container *ngFor="let tag of episode.tagNames; let i = index">
            <a 
              *ngIf="episode.tagSlugs && episode.tagSlugs[i]"
              [routerLink]="['/tag', episode.tagSlugs[i]]"
              class="tag tag-clickable"
              (click)="$event.stopPropagation()"
            >
              #{{ tag }}
            </a>
            <span 
              *ngIf="!episode.tagSlugs || !episode.tagSlugs[i]"
              class="tag"
            >
              #{{ tag }}
            </span>
          </ng-container>
        </div>
      </div>
    </article>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading && !error && episodes.length === 0">
    <div class="empty-icon">🎙️</div>
    <h2>Nessun episodio trovato</h2>
    <p>Non ci sono episodi disponibili al momento.</p>
    <a routerLink="/" class="btn-home">Torna alla home</a>
  </div>

  <!-- Pagination -->
  <nav class="pagination" *ngIf="!isLoading && !error && totalPages > 1">
    <button 
      class="pagination-btn prev"
      [disabled]="!hasPreviousPage"
      (click)="goToPage(currentPage - 1)"
    >
      ← Precedente
    </button>

    <div class="pagination-pages">
      <button 
        *ngIf="pageNumbers[0] > 1"
        class="pagination-page"
        (click)="goToPage(1)"
      >
        1
      </button>
      
      <span *ngIf="pageNumbers[0] > 2" class="pagination-ellipsis">...</span>

      <button 
        *ngFor="let page of pageNumbers"
        class="pagination-page"
        [class.active]="page === currentPage"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>

      <span *ngIf="pageNumbers[pageNumbers.length - 1] < totalPages - 1" class="pagination-ellipsis">...</span>

      <button 
        *ngIf="pageNumbers[pageNumbers.length - 1] < totalPages"
        class="pagination-page"
        (click)="goToPage(totalPages)"
      >
        {{ totalPages }}
      </button>
    </div>

    <button 
      class="pagination-btn next"
      [disabled]="!hasNextPage"
      (click)="goToPage(currentPage + 1)"
    >
      Successivo →
    </button>
  </nav>
</div>
